<nb-layout>
  <nb-layout-column>
    <div *ngIf="responsiveMode === 'lg'"
         class="d-flex flex-column align-items-center justify-content-center position-relative error-502">
      <div class="m-auto pb-5">
        <img class="img-error-502" src="assets/images/errors/error-502.png" alt="">
        <div class="d-flex flex-column align-items-center justify-content-between text-position mt-5">
          <p class="main-text">سرور به صورت موقت قادر به پاسخ‌گویی نمی‌باشد</p>
          <p class="description">صفحه ای که می خواهید در وب سایت تارت به آن دسترسی پیدا کنید در سرور با مشکل مواجه شده
            است. لطفا مجدد تلاش کنید.</p>
          <p class="info">خطای ۵۰۲</p>
\            <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'Email'">
              <a href="mailto:{{supporterContactInfo.email}}">
                راه ارتباطی با پشتیبانی:
                <br/>
                {{supporterContactInfo.email}}
              </a>
            </div>
            <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'PhoneNumber'">
                راه ارتباطی با پشتیبانی:
                <br/>
                {{supporterContactInfo.phoneNumber}}
            </div>
          </div>
        </div>
      </div>
    <div *ngIf="responsiveMode === 'md'" class="m-auto">
      <img src="assets/images/errors/error-502.png" alt="">
      <div class="d-flex flex-column align-items-center justify-content-between">
        <p class="main-text">سرور به صورت موقت قادر به پاسخ‌گویی نمی‌باشد</p>
        <p class="description">صفحه ای که می خواهید در وب سایت تارت به آن دسترسی پیدا کنید در سرور با مشکل مواجه شده
          است.
          لطفا مجدد تلاش کنید.</p>
        <p class="info">خطای ۵۰۲</p>
          <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'Email'">
            <a href="mailto:{{supporterContactInfo.email}}">
              راه ارتباطی با پشتیبانی:
              <br/>
              {{supporterContactInfo.email}}
            </a>
          </div>
          <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'PhoneNumber'">
              راه ارتباطی با پشتیبانی:
              <br/>
              {{supporterContactInfo.phoneNumber}}
          </div>
        </div>
      </div>
  </nb-layout-column>
</nb-layout>

